import { useMemo } from 'react';

import { customizationMachine } from '../../customization.machine';
import { useFetchCustomizationDataActor } from '../useFetchCustomizationDataActor';

import type { MachineImplementationsFrom } from 'xstate5';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Provides the customization machine with its data fetching, for callers that
 * spawn customization actors themselves rather than starting one.
 *
 * NOTE: Pass memoized implementations, or the logic changes on every render.
 */
export const useCustomizationMachineLogic = (implementations: Implementations) => {
  const fetchCustomizationData = useFetchCustomizationDataActor();

  return useMemo(() => {
    return customizationMachine.provide({
      ...implementations,
      actors: {
        ...implementations.actors,
        fetchCustomizationData,
      },
    });
  }, [fetchCustomizationData, implementations]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Implementations = MachineImplementationsFrom<typeof customizationMachine>;
